import React, { ReactElement } from "react";
import {
  ComponentMultiStyleConfig,
  HStack,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { ComponentStyleProps } from "../../../../lib/styles/props/component-style-props";
import { FiCalendar } from "react-icons/fi";
import { CMDatePicker } from "../../../base";
import { CMFrameButtonPopupSearchCondition } from "../CMFrameButtonPopupSearchCondition/CMFrameButtonPopupSearchCondition";

export type CMButtonPopupSearchConditionDateRangeProps = {
  placeholder?: {
    start: string;
    end: string;
  };
  icon?: ReactElement;

  minDate?: {
    year: number;
    month: number;
    day: number;
  };
  maxDate?: {
    year: number;
    month: number;
    day: number;
  };
  /**
   * 開始日時と終了日時の区切り文字として使用する。
   */
  separatorRange: string;
  labelSubmit: string;
  labelClear: string;
  /**
   * クリアボタンの表示制御に使用する。
   */
  hideClearButton?: boolean;

  startDateInternal: { year: number; month: number; day: number } | null;
  endDateInternal: { year: number; month: number; day: number } | null;
  onChangeInternalValue: (
    value: { year: number; month: number; day: number } | null,
    on: "start" | "end",
  ) => void;

  onSubmit: () => void;
  onClear: () => void;
} & ComponentStyleProps;

/**
 * 日付範囲指定検索条件を表示するコンポーネント
 */
export const CMButtonPopupSearchConditionDateRange = ({
  placeholder,
  icon = <FiCalendar />,
  minDate,
  maxDate,
  separatorRange,
  labelSubmit,
  labelClear,
  hideClearButton,

  startDateInternal,
  endDateInternal,
  onChangeInternalValue,

  onSubmit,
  onClear,

  sx,
  ...rest
}: CMButtonPopupSearchConditionDateRangeProps) => {
  const styles = useMultiStyleConfig(
    "CMButtonPopupSearchConditionDateRangeStyles",
  );

  return (
    <CMFrameButtonPopupSearchCondition
      labelSubmit={labelSubmit}
      labelClear={labelClear}
      onSubmit={onSubmit}
      onClear={onClear}
      hideClearButton={hideClearButton}
      sx={{ ...styles.container, ...sx }}
      {...rest}
    >
      <HStack spacing={0}>
        <CMDatePicker
          placeholder={placeholder?.start}
          icon={icon}
          selected={startDateInternal}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(v) => onChangeInternalValue(v, "start")}
        />
        <Text sx={styles.text}>{separatorRange}</Text>
        <CMDatePicker
          placeholder={placeholder?.end}
          icon={icon}
          selected={endDateInternal}
          minDate={minDate}
          maxDate={maxDate}
          onChange={(v) => onChangeInternalValue(v, "end")}
        />
      </HStack>
    </CMFrameButtonPopupSearchCondition>
  );
};

export const CMButtonPopupSearchConditionDateRangeStyles: ComponentMultiStyleConfig =
  {
    parts: ["container", "text"],
    baseStyle: {
      container: {},
      text: {
        pl: 2,
        pr: 2,
      },
    },
  };
